import React, { useState, useRef } from "react";
import { Chart } from "primereact/chart";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Carousel } from 'primereact/carousel';
import { Menu } from 'primereact/menu';
import { Dropdown } from "primereact/dropdown";
import { useNavigate } from "react-router-dom";
import UsuariosDialog from "../components/dialogs/UsuariosDialog";
import CotizacionesDialog from "../components/dialogs/CotizacionesDialog";
import CotizacionesEnviadasDialog from "../components/dialogs/CotizacionesEnviadasDialog";
import AbiertasGanadasDialog from "../components/dialogs/AbiertasGanadasDialog";
import CoberturaDialog from "../components/dialogs/CoberturaDialog";
import GanadasPerdidasDialog from "../components/dialogs/GanadasPerdidasDialog";
import { chartData, chartOptions, goalChartOptions } from "./TableroConfig";
import { useGlobalContext } from "../Config";

const Tablero = () => {
  const [activeTab, setActiveTab] = useState("Mayorista");
  const [isUsuariosDialogVisible, setIsUsuariosDialogVisible] = useState(false);
  const [isCotizacionesDialogVisible, setIsCotizacionesDialogVisible] = useState(false);
  const [isCotizacionesEnviadasDialogVisible, setIsCotizacionesEnviadasDialogVisible] = useState(false);
  const [isAbiertasGanadasDialogVisible, setIsAbiertasGanadasDialogVisible] = useState(false);
  const [isCoberturaDialogVisible, setIsCoberturaDialogVisible] = useState(false);
  const [isGanadasPerdidasDialogVisible, setIsGanadasPerdidasDialogVisible] = useState(false);
  const [dateRange, setDateRange] = useState("mesActual");
  const { isDinar, isSack } = useGlobalContext();
  // Mock Data for Charts

  // Mock Data for Lists
  const vendedoresData = [
    { rank: 1, name: "Lily Ampar Farfan Flores", value: 2 },
  ];

  const familiasData = [
    { rank: "1.-", name: "10602", value: 0 },
  ];

  const topVendedoresData = [
    { rank: "1.-", name: "Lily Ampar Farfan Flores", value: 0 },
  ];

  // Mock Data for Goals Charts
  const chartGoalsVendedor = {
    labels: ['Meta Personal'],
    datasets: [
        {
            label: 'Cumplimiento',
            backgroundColor: '#42A5F5',
            data: [75]
        },
        {
            label: 'Meta',
            backgroundColor: '#FFCDD2',
            data: [100]
        }
    ]
  };

  const chartGoalsJefe = {
      labels: ['Vendedor 1', 'Vendedor 2', 'Vendedor 3', 'Vendedor 4', 'Vendedor 5'],
      datasets: [
          {
              label: 'Cumplimiento',
              backgroundColor: '#66BB6A',
              data: [65, 59, 80, 81, 56]
          },
          {
            label: 'Meta',
            backgroundColor: '#FFCDD2',
            data: [100, 100, 100, 100, 100]
        }
      ]
  };

  const chartGoalsAdmin = {
      labels: ['Equipo A', 'Equipo B', 'Equipo C'],
      datasets: [
          {
              label: 'Cumplimiento',
              backgroundColor: '#FFA726',
              data: [28, 48, 40]
          },
          {
            label: 'Meta',
            backgroundColor: '#FFCDD2',
            data: [100, 100, 100]
        }
      ]
  };

  const navigate = useNavigate();
  const menu = useRef(null);
  const items = [
    {
      label: 'Ingresar Nota De Venta',
      icon: 'pi pi-file',
      command: () => {
        navigate('/nota-venta');
      }
    },
    {
      label: 'Ingresar Cotización Boleta',
      icon: 'pi pi-file',
      command: () => {
        navigate('/boleta');
      }
    },
    {
      label: 'Ingresar Cotización Factura',
      icon: 'pi pi-file-o',
      command: () => {
        navigate('/factura');
      }
    }
  ];

  const chartsResponsiveOptions = [
    {
        breakpoint: '1199px',
        numVisible: 1,
        numScroll: 1
    },
    {
        breakpoint: '991px',
        numVisible: 1,
        numScroll: 1
    },
    {
        breakpoint: '767px',
        numVisible: 1,
        numScroll: 1
    }
  ];

  const dateRangeOptions = [
    { label: 'Mes en curso', value: 'mesActual' },
    { label: 'Últimos 3 meses', value: 'ultimos3Meses' },
    { label: 'Últimos 6 meses', value: 'ultimos6Meses' },
    { label: 'Último año', value: 'ultimoAnio' }
  ];

  const selectedDateRangeLabel = dateRangeOptions.find(option => option.value === dateRange)?.label || '';

  const strategicKpiItems = [
    { title: 'Ingresos Totales', lines: ['$120.000.000 CLP', 'vs mes ant. +12%'] },
    { title: 'Ingresos x Producto Top3', lines: ['1) Acero $40.000.000 CLP', '2) Cemento $32.000.000 CLP'] },
    { title: 'Penetración Mercado', lines: ['32% cobertura', 'Meta 40%'] },
    { title: 'Ingresos Nuevos Clientes', lines: ['$18.000.000 CLP', '15 nuevos clientes'] },
    { title: 'Ingresos Clientes Existentes', lines: ['$102.000.000 CLP', '85 clientes activos'] },
    { title: 'Crecimiento', lines: ['+8% vs mes ant.'] },
    { title: 'CLV', lines: ['CLV promedio $15.000.000 CLP'] },
    { title: 'NPS', lines: ['NPS 67', 'Zona saludable'] },
    { title: 'Vta Perdida', lines: ['$5.000.000 CLP', '12 cotiz. perdidas'] },
    { title: 'Cumplimiento Vta.', lines: ['72% meta', 'Meta $150.000.000 CLP'] },
    { title: 'Ingresos por Mercado Top 3', lines: ['1) Mayorista $66.000.000 CLP', '2) Retail $42.000.000 CLP'] },
    { title: 'Margen', lines: ['Margen 18%'] }
  ];

  const operationalKpiItems = [
    { key: 'oportunidades', title: 'Oportunidades', lines: ['Ult 7 días: 24', 'Mes actual: 86', 'Mes anterior: 73'] },
    { key: 'seguimiento', title: 'Seguimiento', lines: ['Ult 7 días: 78% en curso', 'Mes actual: 82% en curso', 'Mes anterior: 75% en curso'] },
    { key: 'cotizaciones', title: 'Cotizaciones', lines: ['Ult 7 días: 32', 'Mes actual: 120', 'Mes anterior: 98'] },
    { key: 'enviadas', title: 'Enviadas', lines: ['Ult 7 días: 28', 'Mes actual: 105', 'Mes anterior: 90'] },
    { key: 'estados', title: 'Estados', lines: ['Abiertas: $34.000.000 CLP', 'Ganadas: $18.000.000 CLP', 'Perdidas: $12.000.000 CLP'] },
    { key: 'cartera', title: 'Cartera Cliente', lines: ['Clientes activos: 210', 'Visitados mes: 64', 'Cobertura: 31%'] },
    { key: 'ingresosTotales', title: 'Ingresos Totales', lines: ['Ult 7 días: $22.000.000 CLP', 'Mes actual: $96.000.000 CLP', 'Mes anterior: $88.000.000 CLP'] },
    { key: 'usuarios', title: 'Usuarios', lines: ['Activos: 32', 'Licencias: 80', 'Zonas: 10'] }
  ];

  const strategicKpiCardTemplate = (item) => {
    if (!item) return null;

    return (
      <div className="px-1 md:px-2">
        <div
          className="border-1 surface-border border-round-xl p-3 md:p-4 h-full flex flex-column justify-content-center text-center bg-white transition-all transition-duration-200 hover:surface-50"
          style={{ minHeight: '220px' }}
        >
          <div className="text-base md:text-lg font-bold text-blue-800 mb-2">
            {item.title}
          </div>
          {item.lines && item.lines.map((line, index) => (
            <div key={index} className="text-base md:text-lg text-700">
              {line}
            </div>
          ))}
        </div>
      </div>
    );
  };

  const operationalKpiCardTemplate = (item) => {
    if (!item) return null;

    const clickHandlers = {
      estados: () => setIsAbiertasGanadasDialogVisible(true),
      cartera: () => setIsCoberturaDialogVisible(true),
      usuarios: () => setIsUsuariosDialogVisible(true),
      cotizaciones: () => setIsCotizacionesDialogVisible(true),
      enviadas: () => setIsCotizacionesEnviadasDialogVisible(true)
    };

    const onClick = clickHandlers[item.key];

    return (
      <div className="px-1 md:px-2">
        <div
          className="border-1 surface-border border-round-xl p-3 md:p-4 h-full flex flex-column justify-content-center text-center bg-white cursor-pointer transition-all transition-duration-200 hover:surface-50"
          style={{ minHeight: '220px' }}
          onClick={onClick}
        >
          <div className="text-base md:text-lg font-bold text-blue-800 mb-2">
            {item.title}
          </div>
          {item.lines && item.lines.map((line, index) => (
            <div key={index} className="text-base md:text-lg text-700">
              {line}
            </div>
          ))}
        </div>
      </div>
    );
  };

  const chartTemplate = (item) => {
    return (
        <div className="flex flex-column align-items-center p-2 w-full">
             <h5 className="text-blue-500 mb-3">{item.title}</h5>
             {item.content}
        </div>
    );
  }

  const chartCarouselItems = [
      {
          title: 'Tasas de Cierre',
          content: <Chart type="bar" data={chartData} options={chartOptions} style={{ height: '300px', width: '100%' }} />
      },
      {
          title: '¿Cómo vamos? - Cumplimiento Vendedor',
          content: (
            <div className="flex flex-column align-items-center w-full">
                 <h6 className="m-0 mb-2">Mi Cumplimiento</h6>
                 <Chart type="bar" data={chartGoalsVendedor} options={goalChartOptions} style={{ width: '100%', height: '300px' }} />
            </div>
          )
      },
      {
          title: '¿Cómo vamos? - Cumplimiento Jefe',
          content: (
            <div className="flex flex-column align-items-center w-full">
                <h6 className="m-0 mb-2">Cumplimiento del Equipo</h6>
                <Chart type="bar" data={chartGoalsJefe} options={goalChartOptions} style={{ width: '100%', height: '300px' }} />
            </div>
          )
      },
      {
          title: '¿Cómo vamos? - Cumplimiento Administrador',
          content: (
             <div className="flex flex-column align-items-center w-full">
                <h6 className="m-0 mb-2">Cumplimiento por Equipos</h6>
                <Chart type="bar" data={chartGoalsAdmin} options={goalChartOptions} style={{ width: '100%', height: '300px' }} />
            </div>
          )
      }
  ];

  return (
    <div className="grid">
      <div className="col-12"> 
        <div className="relative">

          <div className="absolute border-round">
            <div className="surface-0 border-round shadow-2 px-6 py-5 text-center">
              <div className="text-3xl font-semibold text-900">Tableros KPI/Operacionales</div>
              <div className="text-xl text-600">Próximamente disponibles</div>
            </div>
          </div>


            {/* Tabs */}
            {isSack && (
              <>
                <div className="flex justify-content-between mb-3">
                  <div>
                    <div className="text-2xl font-bold text-blue-900">Tablero Comercial</div>
                    <div className="text-sm text-600">Resumen Operacional y Estratégico</div>
                  </div>
                  <div className="flex">
                    <Button 
                      label="Mayorista" 
                      className={`mr-1 ${activeTab === "Mayorista" ? "p-button-info" : "p-button-secondary p-button-outlined"}`} 
                      onClick={() => setActiveTab("Mayorista")} 
                      icon="pi pi-shopping-cart"
                    />
                    <Button 
                      label="Retail" 
                      className={activeTab === "Retail" ? "p-button-info" : "p-button-secondary p-button-outlined"} 
                      onClick={() => setActiveTab("Retail")} 
                      icon="pi pi-shopping-cart"
                    />
                  </div>

                  <div>
                    <Menu model={items} popup ref={menu} id="popup_menu" />
                    <Button
                      label="Nuevo" 
                      className={"p-button-success"} 
                      onClick={(event) => menu.current.toggle(event)} 
                      icon="pi pi-plus"
                      aria-controls="popup_menu"
                      aria-haspopup
                    />
                  </div>
                </div>

                {/* KPI Cards Section */ }
                <div className="border-round bg-blue-50 px-3 py-4 md:px-5 md:py-5 shadow-1">
                  {/* Operacional arriba */}
                  <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center mb-3">
                    <div>
                      <div className="text-lg font-semibold uppercase tracking-wide text-blue-700">Operacional</div>
                      <div className="text-md text-blue-500">Indicadores del día a día · {selectedDateRangeLabel}</div>
                    </div>
                    <div className="mt-2 md:mt-0 flex align-items-center">
                      <span className="text-sm text-blue-600 mr-2">Rango</span>
                      <Dropdown
                        value={dateRange}
                        options={dateRangeOptions}
                        onChange={(e) => setDateRange(e.value)}
                        optionLabel="label"
                        optionValue="value"
                        className="p-inputtext-sm w-12rem"
                      />
                    </div>
                  </div>

                  <div className="grid">
                    {operationalKpiItems.map((item) => (
                      <div key={item.key} className="col-12 md:col-6 lg:col-3">
                        {operationalKpiCardTemplate(item)}
                      </div>
                    ))}
                  </div>

                  {/* Estratégico abajo */}
                  <div className="mt-5 mb-3">
                    <div className="text-lg font-semibold uppercase tracking-wide text-blue-700">Estratégico</div>
                    <div className="text-md text-blue-500">Visión general de las principales métricas · {selectedDateRangeLabel}</div>
                  </div>

                  <div className="grid">
                    {strategicKpiItems.map((item, index) => (
                      <div key={item.title + index} className="col-12 md:col-4 lg:col-2">
                        {strategicKpiCardTemplate(item)}
                      </div>
                    ))}
                  </div>
                  
                  {/* Charts and Lists Section */}
                  <div className="mt-4">
                    <div className="text-center text-600 text-sm mb-3">Gráficos con las observaciones realizadas</div>
                    <div className="grid">

                      {/* Left Column: Tasas de Cierre & Cumplimiento de Metas */}
                      <div className="col-12 lg:col-6">
                          <div className="surface-0 border-round p-3 md:p-4 shadow-1 h-full">
                              <Carousel value={chartCarouselItems} numVisible={1} numScroll={1} responsiveOptions={chartsResponsiveOptions} itemTemplate={chartTemplate} autoplayInterval={4000} circular />
                          </div>
                      </div>

                      {/* Familias and Top Vendedores */}
                      <div className="col-12 lg:col-6">
                          <div className="flex flex-column gap-3">
                            <div className="surface-0 border-round p-3 shadow-1">
                                <h6 className="text-blue-500 mb-3">Rendimiento por Vendedor</h6>
                                <DataTable value={vendedoresData} className="p-datatable-sm" showHeaders={false}>
                                    <Column field="rank" style={{width: '20px'}}></Column>
                                    <Column field="name"></Column>
                                    <Column field="value" className="text-right"></Column>
                                </DataTable>
                            </div>
                            <div className="surface-0 border-round p-3 shadow-1">
                                <h6 className="text-blue-500 mb-3">Familias mas vendidas (Ton)</h6>
                                <DataTable value={familiasData} className="p-datatable-sm" showHeaders={false}>
                                    <Column field="rank" style={{width: '30px'}}></Column>
                                    <Column field="name"></Column>
                                    <Column field="value" className="text-right"></Column>
                                </DataTable>
                            </div>
                            <div className="surface-0 border-round p-3 shadow-1">
                                <h6 className="text-blue-500 mb-3">Top 10 vendedores (M$)</h6>
                                <DataTable value={topVendedoresData} className="p-datatable-sm" showHeaders={false}>
                                    <Column field="rank" style={{width: '30px'}}></Column>
                                    <Column field="name"></Column>
                                    <Column field="value" className="text-right"></Column>
                                </DataTable>
                            </div>
                            <div className="surface-0 border-round p-3 shadow-1">
                              <h6 className="text-blue-500 mb-3">Compras cerradas últimos 3 meses</h6>
                              <div className="grid grid-nogutter p-3 text-center">
                                  <div className="col-4 border-right-1 surface-border">
                                      <div className="text-3xl font-bold text-blue-600">M$0</div>
                                      <div className="text-500">octubre</div>
                                  </div>
                                  <div className="col-4 border-right-1 surface-border">
                                      <div className="text-3xl font-bold text-blue-600">M$0</div>
                                      <div className="text-500">noviembre</div>
                                  </div>
                                  <div className="col-4">
                                      <div className="text-3xl font-bold text-blue-600">M$0</div>
                                      <div className="text-500">diciembre</div>
                                  </div>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}


        </div>
      </div>

      <UsuariosDialog 
          visible={isUsuariosDialogVisible} 
          onHide={() => setIsUsuariosDialogVisible(false)} 
      />
      <CotizacionesDialog 
          visible={isCotizacionesDialogVisible} 
          onHide={() => setIsCotizacionesDialogVisible(false)} 
      />
      <CotizacionesEnviadasDialog 
          visible={isCotizacionesEnviadasDialogVisible} 
          onHide={() => setIsCotizacionesEnviadasDialogVisible(false)} 
      />
      <AbiertasGanadasDialog 
          visible={isAbiertasGanadasDialogVisible} 
          onHide={() => setIsAbiertasGanadasDialogVisible(false)} 
      />
      <CoberturaDialog 
          visible={isCoberturaDialogVisible} 
          onHide={() => setIsCoberturaDialogVisible(false)} 
      />
      <GanadasPerdidasDialog 
          visible={isGanadasPerdidasDialogVisible} 
          onHide={() => setIsGanadasPerdidasDialogVisible(false)} 
      />
    </div>
  );
};

export default Tablero;